export class PlanGoodsListingModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * Ｐコード詳細情報
   */
  // 表組用項目ＩＤ
  public listingItemID: string = <string>'';

  // 表示内容
  public dispContents: string = <string>'';
}
